import HaveCharge from "@/views/charge/haveCharge/HaveCharge"
export const havecharge = {
    path: '/haveCharge',
    name: 'HaveCharge',
    component: HaveCharge
  }


// WEBPACK FOOTER //
// ./src/router/index/charge/havecharge/index.js